import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSellerQueueContext } from '../../contexts/SellerQueueContext'
import './index.css'

export interface MenuAttendanceIconProps {
  active?: boolean
  colorIcons: string
  highlightColorIcons: string
  fontColor: string
  activeFontColor: string
  position?: number | null
  status?: string
}

/**
 * MenuAttendanceIcon
 * Icon for bottom navigation bar linking to attendance queue page
 * Shows position badge if in queue
 */
export const MenuAttendanceIcon: React.FC<MenuAttendanceIconProps> = ({
  active = false,
  colorIcons,
  highlightColorIcons,
  fontColor,
  activeFontColor,
}) => {
  const navigate = useNavigate()
  const { pluginspace_id } = useParams()
  const { queueEntry } = useSellerQueueContext()

  const handleClick = () => {
    navigate(`/${pluginspace_id}/seller/attendance`)
  }

  const getStatusColor = () => {
    if (!queueEntry?.status || queueEntry.status === 'offline') return 'neutral'
    if (queueEntry.status === 'available') return 'success'
    if (queueEntry.status === 'paused') return 'warning'
    if (queueEntry.status === 'in_service') return 'info'
    return 'neutral'
  }

  return (
    <div className="menu-item" onClick={handleClick}>
      <div className={`menu-attendance-icon status-${getStatusColor()}`}>
        <span className="headset">🎧</span>
        {queueEntry?.position && queueEntry.status !== 'offline' && (
          <span className="position-badge">{queueEntry.position}</span>
        )}
      </div>
      <p
        style={
          active
            ? {
                color: activeFontColor,
                fontWeight: 600,
              }
            : { color: fontColor }
        }
      >
        Atendimento
      </p>
    </div>
  )
}

